var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLiechtenstein(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0c267b",
    d: "M30 12H0V0h30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#be2a2c",
    d: "M30 24H0V12h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f9db5c",
    d: "M11.68 7.1a1 1 0 0 0-.33-.17c.17-.03.21-.29.06-.38.2-.02.23-.32.04-.39.2-.06.16-.39-.06-.4.18-.11.05-.42-.16-.36.13-.17-.1-.4-.28-.29.06-.2-.23-.35-.36-.18 0-.21-.31-.27-.39-.08-.05-.2-.36-.18-.4.02-.06-.19-.37-.14-.39.06-.08-.2-.4-.12-.39.1-.08-.2-.38-.13-.38.08a.2.2 0 0 0-.19-.1c.16-.2.08-.51-.14-.6.1-.09-.06-.28-.1-.36l.08-.07c.18.2.38.07.52-.08-.14-.15-.35-.28-.52-.09l-.07-.06c0-.02.16-.27.13-.29s-.17-.43-.24-.33c-.14.21-.23.4-.04.62L8 3.8c-.17-.19-.39-.07-.52.09.14.15.34.27.52.08q.02.05.07.07c-.03.08-.2.27-.1.35-.22.1-.3.42-.14.6a.2.2 0 0 0-.18.1c0-.2-.3-.26-.39-.08.02-.21-.3-.29-.39-.09-.01-.2-.32-.25-.39-.06-.03-.2-.34-.21-.4-.02-.07-.2-.39-.13-.38.08-.13-.17-.42-.02-.36.18-.18-.12-.4.12-.28.3-.21-.07-.35.24-.17.36-.21 0-.25.33-.05.4-.2.06-.16.36.04.38-.16.1-.11.35.06.38-.67.03.43 1.54.6 1.96.16.5 5.05.5 5.2 0 .34-.43.61-1.41.94-1.78"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiechtenstein);
export default __webpack_public_path__ + "static/media/liechtenstein.10635505bbdcd42b022f64bf2e0f4099.svg";
export { ForwardRef as ReactComponent };